import React, {Component} from "react";
import {connect} from "react-redux";
import {Transition} from "react-transition-group";

import Snow from "../plugins/Snow";

import * as windowService from "../../services/windowService";

class ScreenSaver extends Component {
    nodeRef = null;

    styles = null;

    imageList = null;

    intervalId = null;

    constructor(props) {
        super(props);

        this.nodeRef = React.createRef();
        this.styles = {
            entering: {opacity: 0},
            entered: {opacity: 1},
            exiting: {opacity: 0},
            exited: {opacity: 0}
        };
        this.imageList = windowService.getScreenSaverImageList();

        this.state = {
            usedImage: 0
        };
    }

    componentDidMount = () => {
        this.intervalId = setInterval(this.changeImg, windowService.getScreenSaverInterval() * 1000);
    };

    componentWillUnmount = () => {
        clearInterval(this.intervalId);
    };

    changeImg = () => {
        this.setState({
            usedImage: this.state.usedImage === this.imageList.length - 1 ? 0 : this.state.usedImage + 1
        });
    };

    getImage = () => {
        if (this.imageList[this.state.usedImage].type === "svg") {
            return (
                <img
                    alt="screenSaver"
                    src={
                        "data:image/svg+xml;" +
                        this.imageList[this.state.usedImage].type +
                        ";base64," +
                        this.imageList[this.state.usedImage].img
                    }
                />
            );
        }

        return (
            <img
                alt="screenSaver"
                src={
                    "data:" +
                    this.imageList[this.state.usedImage].type +
                    ";base64," +
                    this.imageList[this.state.usedImage].img
                }
            />
        );
    };

    getScreenSaverContent = () => {
        if (this.imageList.length > 0) {
            return this.getImage();
        }

        return (
            <div className="redlike-logo">
                <div className="redlike-logo-blue" />
            </div>
        );
    };

    getScreenSaver = () => {
        if (this.props.plugins.winter) {
            return (
                <React.Fragment>
                    {this.getScreenSaverContent()}
                    <Snow />
                </React.Fragment>
            );
        }

        return this.getScreenSaverContent();
    };

    render() {
        return (
            <Transition nodeRef={this.nodeRef} in={this.props.screenSaver} timeout={1000} mountOnEnter unmountOnExit>
                {(state) => (
                    <div
                        ref={this.nodeRef}
                        className="screen-saver"
                        style={{
                            transition: "opacity 1000ms ease-in-out",
                            opacity: 0,
                            ...this.styles[state]
                        }}
                    >
                        {this.getScreenSaver()}
                    </div>
                )}
            </Transition>
        );
    }
}

export default ScreenSaver = connect((store) => {
    return {
        screenSaver: store.navigation.screenSaver,
        plugins: store.module.plugins
    };
})(ScreenSaver);
